module.exports = __webpack_public_path__ + "img/reference-entwicklungs-impuls.8616d9e7.webp";